// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shepherd-header {
  width: 100% !important;
  background-color: hsl(var(--popover)) !important;
  padding: 0px !important;
}

.shepherd-title {
  width: 100% !important;
  overflow-wrap: break-word !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  color: hsl(var(--highlight)) !important;
}

.shepherd-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.shepherd-element {
  max-width: 260px !important;
  background-color: hsl(var(--popover)) !important;
}

.shepherd-text {
  width: 100% !important;
  padding: 0px;
  font-size: 0.875rem;
  line-height: 1.5;
  color: hsl(var(--foreground));
}

.shepherd-footer {
  width: 100% !important;
  padding: 0px;
}

.shepherd-button {
  display: -webkit-inline-box !important;
  display: -ms-inline-flexbox !important;
  display: inline-flex !important;
  height: 36px !important;
  min-width: 62px !important;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
      -ms-flex-direction: row !important;
          flex-direction: row !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          justify-content: center !important;
  gap: 5px !important;
  white-space: nowrap !important;
  border-radius: 0.25rem !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(52 140 253 / var(--tw-bg-opacity)) !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  text-align: center !important;
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
  font-size: 14px !important;
  line-height: 1.2 !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform !important;
  transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform !important;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, -webkit-box-shadow, -webkit-transform !important;
  -webkit-transition-duration: 300ms !important;
          transition-duration: 300ms !important;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  -webkit-animation-duration: 300ms !important;
          animation-duration: 300ms !important;
  -webkit-animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
          animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.shepherd-button:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.shepherd-button.shepherd-button-secondary {
  background-color: transparent !important;
  --tw-text-opacity: 1 !important;
  color: rgb(52 140 253 / var(--tw-text-opacity)) !important;
}

.shepherd-arrow::before {
  height: 30px !important;
  width: 30px !important;
  background-color: hsl(var(--popover)) !important;
}

.shepherd-element[data-popper-placement^='left'] > .shepherd-arrow {
  right: 3px !important;
  top: 6px !important;
}

.shepherd-element[data-popper-placement^='top'] > .shepherd-arrow {
  bottom: 2px !important;
}

.shepherd-modal-overlay-container.shepherd-modal-is-visible {
  opacity: .70 !important;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/Onboarding/Onboarding.css"],"names":[],"mappings":"AACE;EAAA,sBAAiC;EAAjC,gDAAiC;EAAjC;AAAiC;;AAIjC;EAAA,sBAAqE;EAArE,oCAAqE;EAArE,0BAAqE;EAArE,2BAAqE;EAArE;AAAqE;;AAIrE;EAAA,oBAAuC;EAAvC,oBAAuC;EAAvC,aAAuC;EAAvC,4BAAuC;EAAvC,6BAAuC;MAAvC,0BAAuC;UAAvC,sBAAuC;EAAvC,QAAuC;EAAvC;AAAuC;;AAIvC;EAAA,2BAAiC;EAAjC;AAAiC;;AAIjC;EAAA,sBAA2D;EAA3D,YAA2D;EAA3D,mBAA2D;EAA3D,gBAA2D;EAA3D;AAA2D;;AAI3D;EAAA,sBAAoB;EAApB;AAAoB;;AAIpB;EAAA,sCAA4R;EAA5R,sCAA4R;EAA5R,+BAA4R;EAA5R,uBAA4R;EAA5R,0BAA4R;EAA5R,yCAA4R;EAA5R,wCAA4R;MAA5R,kCAA4R;UAA5R,8BAA4R;EAA5R,oCAA4R;MAA5R,iCAA4R;UAA5R,8BAA4R;EAA5R,mCAA4R;MAA5R,gCAA4R;UAA5R,kCAA4R;EAA5R,mBAA4R;EAA5R,8BAA4R;EAA5R,iCAA4R;EAA5R,6BAA4R;EAA5R,mEAA4R;EAA5R,6BAA4R;EAA5R,8BAA4R;EAA5R,6BAA4R;EAA5R,+NAA4R;EAA5R,0BAA4R;EAA5R,2BAA4R;EAA5R,+BAA4R;EAA5R,qDAA4R;EAA5R,yCAA4R;EAA5R,8BAA4R;EAA5R,2IAA4R;EAA5R,mIAA4R;EAA5R,mHAA4R;EAA5R,0JAA4R;EAA5R,6CAA4R;UAA5R,qCAA4R;EAA5R,2EAA4R;UAA5R,mEAA4R;EAA5R,4CAA4R;UAA5R,oCAA4R;EAA5R,0EAA4R;UAA5R;AAA4R;;AAA5R;EAAA,yCAA4R;EAA5R;AAA4R;;AAI5R;EAAA,wCAAsC;EAAtC,+BAAsC;EAAtC;AAAsC;;AAItC;EAAA,uBAAsC;EAAtC,sBAAsC;EAAtC;AAAsC;;AAGxC;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAGE;EAAA;AAAkB","sourcesContent":[".shepherd-header {\n  @apply !bg-popover !w-[100%] !p-0;\n}\n\n.shepherd-title {\n  @apply !text-highlight !w-[100%] !break-words !text-xl !leading-[1.5];\n}\n\n.shepherd-content {\n  @apply flex flex-col gap-[8px] p-[12px];\n}\n\n.shepherd-element {\n  @apply !bg-popover !max-w-[260px];\n}\n\n.shepherd-text {\n  @apply text-foreground !w-[100%] p-0 text-lg leading-normal;\n}\n\n.shepherd-footer {\n  @apply !w-[100%] p-0;\n}\n\n.shepherd-button {\n  @apply !inline-flex !h-[36px] !min-w-[62px] !flex-row !items-center !justify-center !gap-[5px] !whitespace-nowrap !rounded !bg-[#348cfd] !px-[10px] !text-center !font-sans !text-[14px] !leading-[1.2] !text-black !outline-none !transition !duration-300 !ease-in-out focus:!outline-none;\n}\n\n.shepherd-button.shepherd-button-secondary {\n  @apply !bg-transparent !text-[#348cfd];\n}\n\n.shepherd-arrow::before {\n  @apply !bg-popover !h-[30px] !w-[30px];\n}\n\n.shepherd-element[data-popper-placement^='left'] > .shepherd-arrow {\n  right: 3px !important;\n  top: 6px !important;\n}\n\n.shepherd-element[data-popper-placement^='top'] > .shepherd-arrow {\n  bottom: 2px !important;\n}\n\n.shepherd-modal-overlay-container.shepherd-modal-is-visible {\n  @apply !opacity-70;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
